import React, { useContext } from 'react'

import dateSwitcherContext from '@/components/pages/production/components/date-switcher/context'
import productionDetailsContext from '@/context/production-details'
import { RelatedProductionsProvider } from '@/context/related-productions'

import DateSwitcherSheetContent from './components/date-switcher-sheet-content'

const DateSwitcherSheet: React.FC = () => {
    const {
        selectors: { dateSwitcherSheetInfo },
    } = useContext(productionDetailsContext)

    const {
        state: { isSheetOpen },
    } = useContext(dateSwitcherContext)

    return (
        <RelatedProductionsProvider enabled={isSheetOpen} initialParams={dateSwitcherSheetInfo?.queryParams}>
            <DateSwitcherSheetContent />
        </RelatedProductionsProvider>
    )
}

export default DateSwitcherSheet
